import React, { ChangeEvent, useState } from 'react'
import { Flex, Card } from 'antd'
import { CButton, CFormInput, CFormSelect } from '@coreui/react-pro'
import { submitCreateOfferLink, submitUpdateOfferLink } from './model'
import { OfferLinkFormItem } from './types'
import { languages } from '../../../../../../libs/languages'
import { isUrlDomainMatching } from 'src/libs/utils'
import { ConfirmModal } from 'src/views/widgets/confirmModal'

type Props = {
  data: OfferLinkFormItem
  mode: 'create' | 'edit'
}

export const OfferLinkForm: React.FC<Props> = ({ data, mode }) => {
  const [offerLinkForm, setOfferLinkForm] = useState<OfferLinkFormItem>(data)
  const [isConfirmDomainOpen, setIsConfirmDomainOpen] = useState(false)

  const handleChangeForm = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value
    const targetName = event.currentTarget.name

    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else {
      value = event.currentTarget.value
    }

    setOfferLinkForm({
      ...offerLinkForm,
      [targetName]: value,
    })
  }

  const handleSave = () => {
    if (mode === 'create') {
      submitCreateOfferLink(offerLinkForm)
    }
    if (mode === 'edit') {
      submitUpdateOfferLink({
        id: offerLinkForm.id,
        link: offerLinkForm.link,
        offerId: offerLinkForm.offerId,
      })
    }
  }

  const handleSaveClick = () => {
    if (!isUrlDomainMatching(offerLinkForm.link)) {
      setIsConfirmDomainOpen(true)
      return
    }

    handleSave()
  }

  const handleConfirmDomainSave = () => {
    setIsConfirmDomainOpen(false)
    handleSave()
  }

  return (
    <Card size="small" style={{ width: 200 }}>
      <Flex vertical gap={5}>
        <Flex vertical gap={5}>
          <CFormSelect
            label="Language"
            name="lang"
            value={offerLinkForm.lang}
            onChange={handleChangeForm}
            disabled={mode === 'edit'}
            required
          >
            {languages.map((language) => (
              <option value={language.value}>{language.label}</option>
            ))}
          </CFormSelect>
          <CFormInput
            type="text"
            name="link"
            value={offerLinkForm.link}
            onChange={handleChangeForm}
            label="Link"
            required
          />
        </Flex>
        <CButton size="sm" onClick={handleSaveClick}>
          Save
        </CButton>
      </Flex>
      <ConfirmModal
        isOpen={isConfirmDomainOpen}
        onSubmit={handleConfirmDomainSave}
        onCancel={() => setIsConfirmDomainOpen(false)}
        title="Подтверждение"
        message="Ссылка использует домен, отличный от headway.partners. Точно сохранить в таком виде?"
      />
    </Card>
  )
}
